



































import SeismicForm from '@/models/SeismicForm'
import Vue from 'vue'

export default Vue.extend({
  name: 'Synthesis',
  props: {
    form: { type: SeismicForm }
  },
  data () {
    return {
      specificPoints: [] as Array<string>
      // localForm: JSON.parse(JSON.stringify(this.form))
    }
  },
  beforeDestroy () {
    this.$emit('saveForm')
  },
  methods: {

  }
})

